/**
 * The focus ring every NEW Build-board control carries (the view toggle, epic
 * cards, Clear filter, requirement-ref links). The theme's mint `--ring`
 * measures 2.52:1 on card and fails WCAG 1.4.11, so these use the primary
 * (aubergine) ring. Shipped `Button`s keep their own ring.
 */
export const BOARD_FOCUS_RING =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background'
